// src/page-sections/PopupSection.js
import React, { useState, useEffect } from 'react';
import { X, ExternalLink, Download, Play, Pause } from 'lucide-react';
const PopupSection = ({ content }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [openCount, setOpenCount] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  // Handle opening popup with session limits
  const handleOpen = () => {
    // Check session limits
    if (maxOpensPerSession > 0) {
      const currentOpens = parseInt(sessionStorage.getItem(sessionKey) || '0');
      if (currentOpens >= maxOpensPerSession) {
        return;
      }
      sessionStorage.setItem(sessionKey, (currentOpens + 1).toString());
    }

    setIsOpen(true);
    setOpenCount(prev => prev + 1);

    // Analytics tracking
    // if (enableAnalytics && typeof gtag !== 'undefined') {
    //   gtag('event', analyticsEvent, {
    //     event_category: 'popup',
    //     event_label: popupTitle || 'Popup',
    //     value: openCount + 1
    //   });
    // }
  };

  // Default content values with all new styling options
  const {
    // Trigger settings
    triggerType = 'button',
    triggerText = 'Open Popup',
    triggerImage = '',
    triggerButtonStyle = 'primary',
    triggerButtonSize = 'medium',
    triggerButtonPosition = 'inline',
    triggerButtonBorderRadius = '6px',
    triggerButtonShadow = 'none',
    triggerButtonCustomShadow = '',
    triggerButtonFullWidth = false,
    triggerImageHoverEffect = 'opacity',
    
    // Auto trigger settings
    scrollTriggerPercentage = 50,
    hoverTargetSelector = '',
    
    // Popup content
    popupTitle = 'Popup Title',
    popupContent = 'Popup content goes here...',
    popupType = 'content',
    iframeUrl = '',
    iframeHeight = '400px',
    
    // Images/Gallery
    images = [],
    
    // Video settings
    videoUrl = '',
    videoAutoplay = false,
    videoControls = true,
    
    // Dimensions & Layout
    popupWidth = '600px',
    popupMaxWidth = '90vw',
    popupHeight = 'auto',
    popupMaxHeight = '90vh',
    popupMinWidth = '300px',
    popupMinHeight = '200px',
    popupPosition = 'center',
    popupZIndex = 1000,
    
    // Colors and appearance
    backgroundColor = '#ffffff',
    textColor = '#333333',
    overlayColor = 'rgba(0, 0, 0, 0.8)',
    borderColor = '#e5e7eb',
    borderWidth = '0px',
    borderStyle = 'solid',
    borderRadius = '8px',
    boxShadow = 'large',
    customBoxShadow = '',
    padding = '2rem',
    backgroundImage = '',
    backgroundSize = 'cover',
    backgroundPosition = 'center',
    backgroundRepeat = 'no-repeat',
    backgroundOverlayOpacity = 0,
    
    // Typography
    fontFamily = 'inherit',
    fontSize = '16px',
    fontWeight = 'normal',
    lineHeight = '1.5',
    letterSpacing = 'normal',
    textAlign = 'left',
    
    // Trigger button styling
    triggerButtonColor = '#3b82f6',
    triggerButtonTextColor = '#ffffff',
    triggerButtonHoverColor = '#2563eb',
    
    // Animation & Effects
    animationType = 'fade',
    animationDuration = 300,
    animationEasing = 'ease',
    animationDelay = 0,
    enableBlurEffect = false,
    blurAmount = 5,
    enableParallax = false,
    parallaxSpeed = 0.5,
    
    // Behavior
    closeOnOverlayClick = true,
    closeOnEscape = true,
    showCloseButton = true,
    preventBodyScroll = true,
    centerOnResize = true,
    closeOnClickInside = false,
    autoCloseAfter = 0,
    maxOpensPerSession = 0,
    
    // Auto-trigger settings
    autoTriggerDelay = 3000,
    autoTriggerOnce = true,
    
    // Gallery settings
    showGalleryNavigation = true,
    showGalleryDots = false,
    galleryAutoplay = false,
    galleryAutoplaySpeed = 5000,
    
    // Responsive settings
    enableResponsive = true,
    mobileWidth = '95vw',
    mobileHeight = 'auto',
    mobilePadding = '1rem',
    mobileFontSize = '14px',
    fullscreenOnMobile = false,
    
    // Advanced settings
    customCssClasses = '',
    customCssStyles = '',
    customAttributes = '',
    enableAnalytics = false,
    analyticsEvent = 'popup_opened',
  } = content;

  // Check if we're on mobile
  const isMobile = window.innerWidth <= 768;

  // Session storage key for tracking opens
  const sessionKey = `popup-opens-${window.location.pathname}`;
  useEffect(() => {
    if (isVisible && !isOpen) {
      handleOpen();
      setIsVisible(false); // Reset for next trigger
    }
  }, [isVisible, isOpen]);
  // Auto trigger effect
 // Auto trigger effect
useEffect(() => {
  if (triggerType === 'auto') {
    const timer = setTimeout(() => {
      // Check if popup should only show once per session
      if (autoTriggerOnce) {
        const sessionKey = `popup_auto_shown_${popupTitle || 'default'}`;
        const hasShownThisSession = sessionStorage.getItem(sessionKey);
        
        if (!hasShownThisSession) {
          setIsVisible(true);
          sessionStorage.setItem(sessionKey, 'true');
        }
      } else {
        // Show popup every time (repeating)
        setIsVisible(true);
      }
    }, autoTriggerDelay || 3000);

    return () => clearTimeout(timer);
  }
}, [triggerType, autoTriggerDelay, autoTriggerOnce, popupTitle]);// Scroll trigger effect
useEffect(() => {
  if (content?.triggerType === 'scroll') {
    const handleScroll = () => {
      const scrollPercentage = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
      
      if (scrollPercentage >= (content?.scrollTriggerPercentage || 50)) {
        // Check if popup should only show once per session
        if (content?.autoTriggerOnce) {
          const sessionKey = `popup_scroll_shown_${content?.popupTitle || 'default'}`;
          const hasShownThisSession = sessionStorage.getItem(sessionKey);
          
          if (!hasShownThisSession) {
            setIsVisible(true);
            sessionStorage.setItem(sessionKey, 'true');
          }
        } else {
          // Show popup every time scroll threshold is reached
          setIsVisible(true);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }
}, [content?.triggerType, content?.scrollTriggerPercentage, content?.autoTriggerOnce, content?.popupTitle]);

// Exit intent effect
useEffect(() => {
  if (content?.triggerType === 'exit') {
    const handleMouseLeave = (e) => {
      if (e.clientY <= 0) {
        // Check if popup should only show once per session
        if (content?.autoTriggerOnce) {
          const sessionKey = `popup_exit_shown_${content?.popupTitle || 'default'}`;
          const hasShownThisSession = sessionStorage.getItem(sessionKey);
          
          if (!hasShownThisSession) {
            setIsVisible(true);
            sessionStorage.setItem(sessionKey, 'true');
          }
        } else {
          // Show popup every time exit intent is detected
          setIsVisible(true);
        }
      }
    };

    document.addEventListener('mouseleave', handleMouseLeave);
    return () => document.removeEventListener('mouseleave', handleMouseLeave);
  }
}, [content?.triggerType, content?.autoTriggerOnce, content?.popupTitle]);
// Exit intent effect
useEffect(() => {
  if (content?.triggerType === 'exit') {
    const handleMouseLeave = (e) => {
      if (e.clientY <= 0) {
        // Check if popup should only show once per session
        if (content?.autoTriggerOnce) {
          const sessionKey = `popup_exit_shown_${content?.popupTitle || 'default'}`;
          const hasShownThisSession = sessionStorage.getItem(sessionKey);
          
          if (!hasShownThisSession) {
            setIsVisible(true);
            sessionStorage.setItem(sessionKey, 'true');
          }
        } else {
          // Show popup every time exit intent is detected
          setIsVisible(true);
        }
      }
    };

    document.addEventListener('mouseleave', handleMouseLeave);
    return () => document.removeEventListener('mouseleave', handleMouseLeave);
  }
}, [content?.triggerType, content?.autoTriggerOnce, content?.popupTitle]);// Exit intent effect
useEffect(() => {
  if (content?.triggerType === 'exit') {
    const handleMouseLeave = (e) => {
      if (e.clientY <= 0) {
        // Check if popup should only show once per session
        if (content?.autoTriggerOnce) {
          const sessionKey = `popup_exit_shown_${content?.popupTitle || 'default'}`;
          const hasShownThisSession = sessionStorage.getItem(sessionKey);
          
          if (!hasShownThisSession && !isVisible) {
            setIsVisible(true);
            sessionStorage.setItem(sessionKey, 'true');
          }
        } else {
          // Show popup every time exit intent is detected
          if (!isVisible) {
            setIsVisible(true);
          }
        }
      }
    };

    document.addEventListener('mouseleave', handleMouseLeave);
    return () => document.removeEventListener('mouseleave', handleMouseLeave);
  }
}, [content?.triggerType, content?.autoTriggerOnce, content?.popupTitle, isVisible]);
  // Hover trigger
  useEffect(() => {
    if (triggerType === 'hover' && hoverTargetSelector) {
      const targetElement = document.querySelector(hoverTargetSelector);
      if (targetElement) {
        const handleMouseEnter = () => handleOpen();
        targetElement.addEventListener('mouseenter', handleMouseEnter);
        return () => targetElement.removeEventListener('mouseenter', handleMouseEnter);
      }
    }
  }, [triggerType, hoverTargetSelector]);

  // Gallery autoplay
  useEffect(() => {
    if (isOpen && popupType === 'gallery' && galleryAutoplay && images.length > 1) {
      const interval = setInterval(() => {
        setCurrentImageIndex(prev => (prev + 1) % images.length);
      }, galleryAutoplaySpeed);
      
      return () => clearInterval(interval);
    }
  }, [isOpen, popupType, galleryAutoplay, galleryAutoplaySpeed, images.length]);

  // Close on escape key
  useEffect(() => {
    if (closeOnEscape) {
      const handleEscape = (e) => {
        if (e.key === 'Escape' && isOpen) {
          handleClose();
        }
      };
      
      document.addEventListener('keydown', handleEscape);
      return () => document.removeEventListener('keydown', handleEscape);
    }
  }, [closeOnEscape, isOpen]);

  // Prevent body scroll when popup is open
  useEffect(() => {
    if (isOpen && preventBodyScroll) {
      const originalOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      
      // Apply blur effect if enabled
      if (enableBlurEffect) {
        document.body.style.filter = `blur(${blurAmount}px)`;
      }
      
      return () => {
        document.body.style.overflow = originalOverflow;
        if (enableBlurEffect) {
          document.body.style.filter = 'none';
        }
      };
    }
  }, [isOpen, preventBodyScroll, enableBlurEffect, blurAmount]);

  // Auto close timer
  useEffect(() => {
    if (isOpen && autoCloseAfter > 0) {
      const timer = setTimeout(() => {
        handleClose();
      }, autoCloseAfter * 1000);
      
      return () => clearTimeout(timer);
    }
  }, [isOpen, autoCloseAfter]);

  // Window resize handler
  useEffect(() => {
    if (centerOnResize && isOpen) {
      const handleResize = () => {
        // Force re-render to recenter
        setIsOpen(false);
        setTimeout(() => setIsOpen(true), 10);
      };

      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }
  }, [centerOnResize, isOpen]);


  // Handle closing popup
  const handleClose = () => {
    setIsOpen(false);
  };

  // Get trigger button classes based on style and size
  const getTriggerButtonClasses = () => {
    let baseClasses = 'inline-flex items-center justify-center font-medium transition-all duration-200 cursor-pointer border-0';
    
    // Size classes
    switch (triggerButtonSize) {
      case 'xs':
        baseClasses += ' px-2 py-1 text-xs';
        break;
      case 'small':
        baseClasses += ' px-3 py-1.5 text-sm';
        break;
      case 'large':
        baseClasses += ' px-8 py-4 text-lg';
        break;
      case 'xl':
        baseClasses += ' px-10 py-5 text-xl';
        break;
      default: // medium
        baseClasses += ' px-6 py-3 text-base';
    }

    // Style classes
    switch (triggerButtonStyle) {
      case 'outline':
        baseClasses += ' border-2 bg-transparent';
        break;
      case 'ghost':
        baseClasses += ' bg-transparent hover:bg-opacity-10';
        break;
      case 'link':
        baseClasses += ' bg-transparent underline hover:no-underline';
        break;
      default:
        break;
    }

    // Position classes
    if (triggerButtonPosition !== 'inline') {
      switch (triggerButtonPosition) {
        case 'center':
          baseClasses += ' mx-auto block';
          break;
        case 'left':
          baseClasses += ' mr-auto';
          break;
        case 'right':
          baseClasses += ' ml-auto';
          break;
        case 'fixed-bottom-right':
          baseClasses += ' fixed bottom-4 right-4 z-50';
          break;
        case 'fixed-bottom-left':
          baseClasses += ' fixed bottom-4 left-4 z-50';
          break;
        case 'fixed-top-right':
          baseClasses += ' fixed top-4 right-4 z-50';
          break;
        case 'fixed-top-left':
          baseClasses += ' fixed top-4 left-4 z-50';
          break;
      }
    }

    if (triggerButtonFullWidth) {
      baseClasses += ' w-full';
    }
    
    return baseClasses;
  };

  // Get popup position classes
  const getPopupPositionClasses = () => {
    switch (popupPosition) {
      case 'top':
        return 'items-start justify-center';
      case 'bottom':
        return 'items-end justify-center';
      case 'left':
        return 'items-center justify-start';
      case 'right':
        return 'items-center justify-end';
      case 'top-left':
        return 'items-start justify-start';
      case 'top-right':
        return 'items-start justify-end';
      case 'bottom-left':
        return 'items-end justify-start';
      case 'bottom-right':
        return 'items-end justify-end';
      default: // center
        return 'items-center justify-center';
    }
  };

  // Get box shadow styles
  const getBoxShadowStyle = () => {
    switch (boxShadow) {
      case 'none':
        return 'none';
      case 'small':
        return '0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)';
      case 'medium':
        return '0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23)';
      case 'large':
        return '0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23)';
      case 'xl':
        return '0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22)';
      case 'custom':
        return customBoxShadow || 'none';
      default:
        return '0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23)';
    }
  };

  // Get animation classes
  const getAnimationClasses = () => {
    const duration = `duration-${animationDuration}`;
    const easing = animationEasing;
    let baseClasses = `transition-all ${duration}`;
    
    if (!isOpen) {
      switch (animationType) {
        case 'scale':
          return `${baseClasses} scale-95 opacity-0`;
        case 'slide':
          return `${baseClasses} translate-y-4 opacity-0`;
        case 'slideLeft':
          return `${baseClasses} -translate-x-4 opacity-0`;
        case 'slideRight':
          return `${baseClasses} translate-x-4 opacity-0`;
        case 'bounce':
          return `${baseClasses} scale-95 opacity-0`;
        case 'rotate':
          return `${baseClasses} rotate-180 opacity-0`;
        case 'flip':
          return `${baseClasses} rotateY-180 opacity-0`;
        case 'zoom':
          return `${baseClasses} scale-50 opacity-0`;
        case 'elastic':
          return `${baseClasses} scale-110 opacity-0`;
        case 'none':
          return '';
        default: // fade
          return `${baseClasses} opacity-0`;
      }
    }
    
    switch (animationType) {
      case 'scale':
        return `${baseClasses} scale-100 opacity-100`;
      case 'slide':
        return `${baseClasses} translate-y-0 opacity-100`;
      case 'slideLeft':
        return `${baseClasses} translate-x-0 opacity-100`;
      case 'slideRight':
        return `${baseClasses} translate-x-0 opacity-100`;
      case 'bounce':
        return `${baseClasses} scale-100 opacity-100 animate-bounce`;
      case 'rotate':
        return `${baseClasses} rotate-0 opacity-100`;
      case 'flip':
        return `${baseClasses} rotateY-0 opacity-100`;
      case 'zoom':
        return `${baseClasses} scale-100 opacity-100`;
      case 'elastic':
        return `${baseClasses} scale-100 opacity-100`;
      case 'none':
        return '';
      default: // fade
        return `${baseClasses} opacity-100`;
    }
  };

  // Navigate gallery
  const navigateGallery = (direction) => {
    if (direction === 'next') {
      setCurrentImageIndex(prev => (prev + 1) % images.length);
    } else {
      setCurrentImageIndex(prev => (prev - 1 + images.length) % images.length);
    }
  };

  // Render popup content based on type
  const renderPopupContent = () => {
    switch (popupType) {
      case 'iframe':
        return iframeUrl ? (
          <iframe
            src={iframeUrl}
            width="100%"
            height={iframeHeight}
            frameBorder="0"
            allowFullScreen
            className="border-0 rounded"
          />
        ) : null;

      case 'image':
        return images.length > 0 ? (
          <div className="text-center">
            <img 
              src={images[0]?.url || images[0]} 
              alt={images[0]?.alt || 'Popup image'} 
              className="max-w-full max-h-full object-contain"
            />
            {images[0]?.caption && (
              <p className="mt-2 text-sm opacity-75">{images[0].caption}</p>
            )}
          </div>
        ) : null;
        
      case 'video':
        return videoUrl ? (
          <div className="text-center">
            <video 
              className="max-w-full max-h-full"
              controls={videoControls}
              autoPlay={videoAutoplay}
              style={{ borderRadius: borderRadius }}
            >
              <source src={videoUrl} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        ) : null;
        
      case 'gallery':
        return images.length > 0 ? (
          <div className="text-center relative">
            <div className="relative">
              <img 
                src={images[currentImageIndex]?.url || images[currentImageIndex]} 
                alt={images[currentImageIndex]?.alt || `Gallery image ${currentImageIndex + 1}`}
                className="max-w-full max-h-full object-contain"
              />
              
              {/* Gallery Navigation */}
              {showGalleryNavigation && images.length > 1 && (
                <>
                  <button
                    onClick={() => navigateGallery('prev')}
                    className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-2 rounded-full hover:bg-opacity-75 transition-all"
                  >
                    ←
                  </button>
                  <button
                    onClick={() => navigateGallery('next')}
                    className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-2 rounded-full hover:bg-opacity-75 transition-all"
                  >
                    →
                  </button>
                </>
              )}
            </div>
            
            {/* Image caption */}
            {images[currentImageIndex]?.caption && (
              <p className="mt-2 text-sm opacity-75">{images[currentImageIndex].caption}</p>
            )}
            
            {/* Gallery dots */}
            {showGalleryDots && images.length > 1 && (
              <div className="flex justify-center space-x-2 mt-4">
                {images.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentImageIndex(index)}
                    className={`w-2 h-2 rounded-full transition-all ${
                      index === currentImageIndex 
                        ? 'bg-blue-500' 
                        : 'bg-gray-300 hover:bg-gray-400'
                    }`}
                  />
                ))}
              </div>
            )}
            
            {/* Image counter */}
            <div className="absolute top-2 right-2 bg-black bg-opacity-50 text-white px-2 py-1 rounded text-sm">
              {currentImageIndex + 1} / {images.length}
            </div>
          </div>
        ) : null;
        default: // content
        return (
          <div style={{ textAlign: content.contentAlignment || 'left' }}>
            {popupTitle && (
              <h3 className="text-xl font-semibold mb-4" style={{ color: textColor }}>
                {popupTitle}
              </h3>
            )}
            
            {/* Render based on content layout */}
            {(() => {
              const layoutType = content.contentLayout || 'text-only';
              const hasImage = content.contentImage && (layoutType === 'text-with-image' || layoutType === 'image-text-split');
              const hasVideo = content.contentVideo && (layoutType === 'text-with-video' || layoutType === 'video-text-split');
              const isSplit = layoutType.includes('-split');
      
              if (layoutType === 'text-only') {
                return (
                  <div 
                    className="prose max-w-none"
                    style={{ 
                      color: content.contentTextColor || textColor,
                      fontSize: content.contentFontSize || '16px'
                    }}
                    dangerouslySetInnerHTML={{ __html: popupContent }}
                  />
                );
              }
      
              if (isSplit) {
                const isVerticalSplit = (content.contentImagePosition === 'top' || content.contentImagePosition === 'bottom') ||
                                        (content.contentVideoPosition === 'top' || content.contentVideoPosition === 'bottom');
                
                return (
                  <div className={`flex ${isVerticalSplit ? 'flex-col' : 'flex-row'} gap-4 items-start`}>
                    {/* Media Element - Check position for ordering */}
                    {((hasImage && (content.contentImagePosition === 'left' || content.contentImagePosition === 'top')) ||
                      (hasVideo && (content.contentVideoPosition === 'left' || content.contentVideoPosition === 'top'))) && (
                      <div className="flex-shrink-0" style={{ width: hasImage ? (content.contentImageWidth || '300px') : (content.contentVideoWidth || '400px') }}>
                        {hasImage && (
                          <img 
                            src={content.contentImage} 
                            alt="Content image" 
                            className="w-full h-auto object-cover"
                            style={{ borderRadius: content.contentImageBorderRadius || '8px' }}
                          />
                        )}
                        {hasVideo && (
                          <video 
                            className="w-full h-auto"
                            controls={content.contentVideoControls !== false}
                            autoPlay={content.contentVideoAutoplay || false}
                            style={{ borderRadius: content.contentImageBorderRadius || '8px' }}
                          >
                            <source src={content.contentVideo} type="video/mp4" />
                          </video>
                        )}
                      </div>
                    )}
                    
                    {/* Text Content */}
                    <div className="flex-grow">
                      <div 
                        className="prose max-w-none"
                        style={{ 
                          color: content.contentTextColor || textColor,
                          fontSize: content.contentFontSize || '16px'
                        }}
                        dangerouslySetInnerHTML={{ __html: popupContent }}
                      />
                    </div>
      
                    {/* Media Element - Right/Bottom position */}
                    {((hasImage && (content.contentImagePosition === 'right' || content.contentImagePosition === 'bottom')) ||
                      (hasVideo && (content.contentVideoPosition === 'right' || content.contentVideoPosition === 'bottom'))) && (
                      <div className="flex-shrink-0" style={{ width: hasImage ? (content.contentImageWidth || '300px') : (content.contentVideoWidth || '400px') }}>
                        {hasImage && (
                          <img 
                            src={content.contentImage} 
                            alt="Content image" 
                            className="w-full h-auto object-cover"
                            style={{ borderRadius: content.contentImageBorderRadius || '8px' }}
                          />
                        )}
                        {hasVideo && (
                          <video 
                            className="w-full h-auto"
                            controls={content.contentVideoControls !== false}
                            autoPlay={content.contentVideoAutoplay || false}
                            style={{ borderRadius: content.contentImageBorderRadius || '8px' }}
                          >
                            <source src={content.contentVideo} type="video/mp4" />
                          </video>
                        )}
                      </div>
                    )}
                  </div>
                );
              }
      
              // Non-split layouts (text-with-image, text-with-video)
              return (
                <div>
                  {((content.contentImagePosition === 'top' && hasImage) || (content.contentVideoPosition === 'top' && hasVideo)) && (
                    <div className="mb-4 text-center">
                      {hasImage && (
                        <img 
                          src={content.contentImage} 
                          alt="Content image" 
                          className="inline-block max-w-full h-auto object-cover"
                          style={{ 
                            width: content.contentImageWidth || '300px',
                            borderRadius: content.contentImageBorderRadius || '8px' 
                          }}
                        />
                      )}
                      {hasVideo && (
                        <video 
                          className="inline-block max-w-full h-auto"
                          controls={content.contentVideoControls !== false}
                          autoPlay={content.contentVideoAutoplay || false}
                          style={{ 
                            width: content.contentVideoWidth || '400px',
                            borderRadius: content.contentImageBorderRadius || '8px' 
                          }}
                        >
                          <source src={content.contentVideo} type="video/mp4" />
                        </video>
                      )}
                    </div>
                  )}
                  
                  <div 
                    className="prose max-w-none"
                    style={{ 
                      color: content.contentTextColor || textColor,
                      fontSize: content.contentFontSize || '16px'
                    }}
                    dangerouslySetInnerHTML={{ __html: popupContent }}
                  />
                  
                  {((content.contentImagePosition === 'bottom' && hasImage) || (content.contentVideoPosition === 'bottom' && hasVideo)) && (
                    <div className="mt-4 text-center">
                      {hasImage && (
                        <img 
                          src={content.contentImage} 
                          alt="Content image" 
                          className="inline-block max-w-full h-auto object-cover"
                          style={{ 
                            width: content.contentImageWidth || '300px',
                            borderRadius: content.contentImageBorderRadius || '8px' 
                          }}
                        />
                      )}
                      {hasVideo && (
                        <video 
                          className="inline-block max-w-full h-auto"
                          controls={content.contentVideoControls !== false}
                          autoPlay={content.contentVideoAutoplay || false}
                          style={{ 
                            width: content.contentVideoWidth || '400px',
                            borderRadius: content.contentImageBorderRadius || '8px' 
                          }}
                        >
                          <source src={content.contentVideo} type="video/mp4" />
                        </video>
                      )}
                    </div>
                  )}
                </div>
              );
            })()}
          </div>
        );
      }
  };

  // Get trigger button styles
  const getTriggerButtonStyles = () => {
    const styles = {
      backgroundColor: triggerButtonColor,
      color: triggerButtonTextColor,
      borderRadius: triggerButtonBorderRadius,
      borderColor: triggerButtonColor,
    };

    // Add shadow
    if (triggerButtonShadow !== 'none') {
      switch (triggerButtonShadow) {
        case 'small':
          styles.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.12)';
          break;
        case 'medium':
          styles.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
          break;
        case 'large':
          styles.boxShadow = '0 10px 15px rgba(0, 0, 0, 0.1)';
          break;
        case 'custom':
          styles.boxShadow = triggerButtonCustomShadow;
          break;
      }
    }

    return styles;
  };

  // Get trigger image hover styles
  const getTriggerImageHoverStyles = () => {
    switch (triggerImageHoverEffect) {
      case 'scale':
        return 'hover:scale-105';
      case 'brightness':
        return 'hover:brightness-110';
      case 'grayscale':
        return 'hover:grayscale';
      case 'blur':
        return 'hover:blur-sm';
      case 'rotate':
        return 'hover:rotate-3';
      case 'opacity':
      default:
        return 'hover:opacity-80';
    }
  };

  // Render trigger element
  const renderTrigger = () => {
    if (triggerType === 'image' && triggerImage) {
      return (
        <img
          src={triggerImage}
          alt="Click to open popup"
          className={`cursor-pointer transition-all duration-200 ${getTriggerImageHoverStyles()}`}
          onClick={handleOpen}
        />
      );
    }
    
    if (triggerType === 'button') {
      return (
        <button
          className={getTriggerButtonClasses()}
          style={getTriggerButtonStyles()}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = triggerButtonHoverColor;
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = triggerButtonColor;
          }}
          onClick={handleOpen}
        >
          {triggerText}
        </button>
      );
    }

    return null;
  };

  // Get responsive styles
  const getResponsiveStyles = () => {
    if (!enableResponsive || !isMobile) return {};

    const responsiveStyles = {};

    if (fullscreenOnMobile) {
      responsiveStyles.width = '100vw';
      responsiveStyles.height = '100vh';
      responsiveStyles.maxWidth = '100vw';
      responsiveStyles.maxHeight = '100vh';
      responsiveStyles.borderRadius = '0';
    } else {
      if (mobileWidth) responsiveStyles.width = mobileWidth;
      if (mobileHeight) responsiveStyles.height = mobileHeight;
      if (mobilePadding) responsiveStyles.padding = mobilePadding;
      if (mobileFontSize) responsiveStyles.fontSize = mobileFontSize;
    }

    return responsiveStyles;
  };

  // Parse custom attributes
  const parseCustomAttributes = () => {
    if (!customAttributes) return {};
    
    try {
      const attrs = {};
      const pairs = customAttributes.split(' ');
      pairs.forEach(pair => {
        const [key, value] = pair.split('=');
        if (key && value) {
          attrs[key] = value.replace(/"/g, '');
        }
      });
      return attrs;
    } catch (e) {
      return {};
    }
  };

  return (
    <>
      {/* Trigger Element */}
      {(triggerType === 'button' || triggerType === 'image') && renderTrigger()}
      
      {/* Popup Overlay */}
      {isOpen && (
        <div
          className={`fixed inset-0 flex p-4 ${getPopupPositionClasses()}`}
          style={{ 
            backgroundColor: overlayColor,
            zIndex: popupZIndex,
            animationDelay: `${animationDelay}ms`
          }}
          onClick={closeOnOverlayClick ? handleClose : undefined}
        >
          {/* Popup Container */}
          <div
            className={`relative max-w-full max-h-full overflow-auto ${getAnimationClasses()} ${customCssClasses}`}
            style={{
              backgroundColor,
              color: textColor,
              width: popupWidth,
              maxWidth: popupMaxWidth,
              height: popupHeight,
              maxHeight: popupMaxHeight,
              minWidth: popupMinWidth,
              minHeight: popupMinHeight,
              borderRadius,
              padding: popupType === 'image' || popupType === 'video' || popupType === 'gallery' ? '1rem' : padding,
              borderWidth,
              borderStyle,
              borderColor,
              boxShadow: getBoxShadowStyle(),
              fontFamily,
              fontSize,
              fontWeight,
              lineHeight,
              letterSpacing,
              textAlign,
              backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none',
              backgroundSize,
              backgroundPosition,
              backgroundRepeat,
              ...getResponsiveStyles(),
              ...customCssStyles ? JSON.parse(`{${customCssStyles}}`) : {},
            }}
            onClick={closeOnClickInside ? handleClose : (e) => e.stopPropagation()}
            {...parseCustomAttributes()}
          >
            {/* Background overlay if background image exists */}
            {backgroundImage && backgroundOverlayOpacity > 0 && (
              <div
                className="absolute inset-0 rounded"
                style={{
                  backgroundColor: backgroundColor,
                  opacity: backgroundOverlayOpacity,
                  borderRadius: borderRadius,
                }}
              />
            )}

            {/* Close Button */}
            {showCloseButton && (
              <button
                className="absolute top-2 right-2 z-10 bg-black bg-opacity-50 text-white hover:bg-opacity-75 rounded-full p-2 transition-all"
                onClick={handleClose}
              >
                <X size={16} />
              </button>
            )}
            
            {/* Popup Content */}
            <div className="relative z-0">
              {renderPopupContent()}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PopupSection;